<!-- 消息通知 -->
<template>
	<div class="box">
		<div class="notfinish">
			<div class="titleBar" :style="{backgroundImage:'url('+(backgroundImgUrl)+')'}">
				<div class="title" ref="titleText">{{title}}</div>
				<div class="titleBottomBar"></div>
				<div class="questionCount">{{surveyData.answered}}/<span class="small">{{surveyData.count}}题</span></div>
			</div>
			<div class="whiteBox" ref="whiteBox" :class="textSize">
				<div class="qanda" v-for="(surveyList,index) in surveyData.list" :key="surveyList.id">
					<div class="question" :data-questionId="surveyList.id">{{index+1}}. <img alt="" v-if="surveyList.contentImage" :src="bindImage(surveyList.contentImage)" />{{surveyList.question}}</div>
					<div v-for="answerList in surveyList.answers" :key="answerList.id">
						<el-radio-group v-model="surveyResultData[index].answer" @change="checkAnswerd(index)">
							<el-radio :label="answerList.responseNumber"><img alt="" v-if="answerList.contentImage" :src="bindImage(answerList.contentImage)" />{{answerList.response}}</el-radio>
						</el-radio-group>
					</div>
				</div>

				<el-button type="primary" @click="submitAnswer">提交答卷</el-button>
			</div>
			<div class="secondConfirm" v-show="questionDone">
				<div class="layerInfoText">感谢您参加BMW/MINI经销商<br>{{title}}</div>
				<div class="buttons">
					<el-button class="submit" type="primary" @click="confirmSubmitAnswer">提交</el-button>
					<el-button class="cancel" type="primary" @click="confirmCancel">取消</el-button>
				</div>
			</div>
		</div>
		<!-- <div class="finished" v-if="finished"><img alt="" src="@/assets/img/online/finished.png" alt=""></div> -->
	</div>
</template>
<script>
	/* eslint-disable */
	export default {
		components: {},
		data() {
			return {
				backgroundImgUrl: require("../../../assets/img/online/survey_top_new.jpg"),
				backgroundImgRate: 0,
				mainBoxHeight: 0,
				changeingText: 0,
				textSize: 'middle',
				titleWidth: '',
				title: '',
				questionDone: false,
				questionDoneSecond: true,
				finished: false,
				apiInfo: {
					bizId: '5ea3086f2eb8b551012eb8ba7cc00001',
					beginTime: '',
					taskId: '1301344334037168130', // 1 人格 2 情景
					token: '',
					examDetailParams: [],
				},
				dataForm: {
					orgId: '',
					userCode: '',
					taskName: '',
					processName: '',
					startDateModify: [],
					startDateStart: '',
					startDateEnd: '',
					arriveDateModify: [],
					arriveDateStart: '',
					arriveDateEnd: '',
					userId: ''
				},
				surveyData: {
					answered: 0,
					count: 0,
					list: []
				},
				surveyResultData: [],
			}
		},
		// activated() {
		// 	this.$request.get('/sys/commuser/userInfo').then((res) => {
		// 		this.dataForm.userId = res.user.userId
		// 		// this.$store.state.user.id = res.user.id
		// 		// this.getDataList()
		// 	}).catch(() => {})
		// },

		watch: {
			// 监听,当路由发生变化的时候执行
			$route: {
				handler: function(val, oldVal) {
					if (val.query.testInfoName) {
						this.init()
					}
				},
				// 深度观察监听
				deep: true
			}
		},
		created() {
			var that = this;
		},
		mounted() {
			var that = this;
			// window.onresize = () => {
			// 	that.setmainBoxHeight();
			// }
			// this.$nextTick(() => {
			// 	this.getImgWandH(this.backgroundImgUrl, function(result) {
			// 		// 获取主背景的宽高比
			// 		that.backgroundImgRate = result;
			// 		that.setmainBoxHeight();
			// 	});
			// 	this.settitleBarWidth();
			// })
			this.init()
		},
		methods: {
			// 初始化数据
			init() {
				this.textSize = this.$route.query.textSize;
				this.title = this.$route.query.testInfoName;
				this.apiInfo.bizId = this.$route.query.bizId;
				this.apiInfo.taskId = this.$route.query.testInfoId;
				// this.settitleBarWidth();
				// 获取问题列表
				let token = sessionStorage.getItem('oauth_token')
				if (!token) {
					this.$message.warning(this.$t('res.getCheckTokenError')) // 获取access_token失败
					return;
					//this.checkAccessTokenForZCHC(token)
				} else {
					this.apiInfo.token = token;
					this.$request.get('/online/exam/questions/' + this.apiInfo.taskId, {
						bizId: this.apiInfo.bizId,
						token: this.apiInfo.token,
					}).then((res, total, code, data) => {
						if (code == 1) {
							this.surveyData.list = res
							// console.log(this.surveyData.list)
							for (let i = 0; i < res.length; i++) {
								var surveyResultDataTemp = {
									"answer": null,
									"questionMainId": res[i].id
								}
								this.surveyResultData.push(surveyResultDataTemp)
							}
							this.surveyData.count = res.length;
							var d = new Date();
							var n = d.getTime();
							this.apiInfo.beginTime = n;
						} else {
							this.$message.warning(data.msg)
						}
					}).catch((err) => {
						console.log(err)
					})
				}
			},
			// 获取图片宽高比
			getImgWandH(imgUrl, callback) {
				let img = new Image()
				img.src = imgUrl;
				img.onload = function() {
					callback(img.width / img.height);
				}
			},
			// 动态设置DOM高度
			setmainBoxHeight() {
				this.mainBoxHeight = this.$refs.mainBox.clientWidth / this.backgroundImgRate;
			},
			settitleBarWidth() {
				this.titleWidth = this.$refs.titleText.clientWidth;
			},
			checkAnswerd(index, questionMainId) {
				var answered = 0;
				// var answered = this.surveyData.answered;
				for (var i = 0; i < this.surveyResultData.length; i++) {
					if (this.surveyResultData[i].answer != null) {
						answered++;
					}
				}
				this.surveyData.answered = answered;
			},
			// 提交问卷
			submitAnswer() {
				if (this.surveyData.answered < this.surveyData.count) {
					this.$message.warning('请填写全部问题答案')
					// this.$alert('请填写全部问题答案');
					// $top = $(".fail-info-input").eq(i).offset().top-50;
					var nullIndex = 0;
					for (var i = (this.surveyResultData.length - 1); i >= 0; i--) {
						if (this.surveyResultData[i].answer == null) {
							nullIndex = i;
						}
					}
					// console.log(this.surveyResultData, nullIndex)
					var scrollY = this.$refs.whiteBox.childNodes[nullIndex].offsetTop - this.$refs.whiteBox.childNodes[nullIndex].offsetHeight;
					this.$refs.whiteBox.scrollTo(0, scrollY)
				} else {
					this.questionDone = true;
				}
			},
			// 二次确认
			confirmSubmitAnswer() {
				if (this.questionDoneSecond) {
					this.questionDoneSecond = false;
					this.apiInfo.examDetailParams = this.surveyResultData;
					this.$request.post(
						'/online/exam/score', {
							"bizId": this.apiInfo.bizId,
							"beginTime": this.apiInfo.beginTime,
							"bizType": this.apiInfo.taskId,
							"examDetailParams": this.surveyResultData,
							"token": this.apiInfo.token
						}).then((res, msg, code, data) => {
						// console.log(res, msg, code, data)
						if (code == 1) {
							// console.log("问卷提交完毕")
							// this.finished = true;
							this.$eventHub.$emit('completeSurvey', '')
							this.tabRemove()
						} else {
							this.$message.warning(data.msg)
							this.questionDoneSecond = true;
						}
						// 待填坑，错误提示
					}).catch((err) => {
						console.log(err)
					})
				}
			},
			confirmCancel() {
				this.questionDone = false;
			},
			// 删除当前页面
			tabRemove() {
				let tabName = this.$store.state.contentTabsActiveName
				if (tabName === 'home') {
					return false
				}
				this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
					item => item.name !== tabName
				)
				if (this.$store.state.contentTabs.length <= 0) {
					this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
						'home'
					return false
				}
				// 当前选中tab被删除
				if (tabName === this.$store.state.contentTabsActiveName) {
					this.$router.push({
						name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name
					})
				}
			},
			bindImage(img) {
				return require("@/assets/img/online/"+img);
			}
		}
	}
</script>
<style lang="scss" scoped>
	.box {
		width: 100%;
		background-color: #fff;
		position: relative;

		.titleBar {
			height: 135px;
			position: relative;
			background-repeat: no-repeat;
			background-size: auto 135px;
			.title {
				color: #ffffff;
				font-size: 30px;
				font-weight:bold;
				position: absolute;
				left: 26px;
				top: 50px;
				line-height: 30px;
			}

			.titleBottomBar {
				position: absolute;
				height: 4px;
				background-color: #ffffff;
				left: 26px;
				top: 95px;
				width: 65px;
			}

			.questionCount {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				right: 30px;
				color: #ffffff;
				font-size: 20px;
				font-weight:bold;
			}
		}
		.topImg {
			min-height: 60px;
			background-image: url('../../../assets/img/online/survey_top_new.jpg');
			background-repeat: no-repeat;
			background-size: 100% auto;
			background-color: #fff;
			position: relative;

			.title {
				color: #ffffff;
				font-size: 18px;
				position: absolute;
				left: 26px;
				top: 12px;
			}

			.titleBottomBar {
				position: absolute;
				height: 4px;
				background-color: #1d68d4;
				left: 26px;
				bottom: -5px;
			}

			.surveyProcess {
				color: #ffffff;
				font-size: 18px;
				position: absolute;
				top: 12px;

				.small {
					font-size: 0.6em;
				}
			}
		}

		.whiteBox {
			margin-top: 5px;
			max-height: calc(100vh - 50px - 38px - 30px - 60px);
			background-color: white;
			overflow-y: auto;
			padding: 20px 26px;

			.qanda {
				margin-top: 1em;
				margin-bottom: 1em;

				.question {
					line-height: 2em;
					margin-bottom: 0.3em;
				}

				.el-radio {
					display: block;
					line-height: 2em;
					white-space: normal;
				}

				.el-radio__input.is-checked .el-radio__inner {
					border-color: #1d68d4;
					background: #1d68d4;
				}

				.el-radio__input.is-checked+.el-radio__label {
					color: #1d68d4;
				}
			}

			&.small {
				font-size: 14px;

				.qanda {
					.el-radio__label {
						font-size: 14px;
					}
				}
			}

			&.middle {
				font-size: 18px;

				.qanda {
					.el-radio__label {
						font-size: 18px;
					}
				}
			}

			&.big {
				font-size: 22px;

				.qanda {
					.el-radio__label {
						font-size: 22px;
					}
				}
			}
		}

		.whiteBox::-webkit-scrollbar {
			/*滚动条整体样式*/
			width: 6px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 0px;
		}

		.whiteBox::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
			background: #1d68d4;
		}

		.whiteBox::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			// box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			// border-radius: 10px;
			background: #fff;
		}

		.el-button--primary {
			display: block;
			margin: 10px auto;
			width: 220px;
			height: 50px;
			font-size: 16px;
			font-weight: bold;
		}

		.secondConfirm {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			display: flex;
			flex-direction: column;
			justify-content: center;
			background-image: url('../../../assets/img/online/second_confirm_layer.png');
			background-size: 100% 100%;
			width:631px;height:353px;
			.layerInfoText {
				width: 100%;
				text-align: center;
				font-size:24px;
				font-weight:bold;
				margin:10px auto 20px;
			}
			.buttons {
				display: flex;
				justify-content: center;
				width: 100%;
				.submit,
				.cancel {
					width: 30%;
					margin-left:10px;
					margin-right:10px;
					cursor: pointer;
				}
			}
		}

		.finished {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 100;
			width: 100%;

			img {
				width: 100%;
			}
		}
	}
</style>
